import * as React from 'react';
import { Popover } from 'antd';
import { QuestionIcon, PopoverContent } from '.';

interface Props {
    content: string | React.ReactNode;
}

export default function QuestionPopover(props: Props) {
    const popoverContent = <PopoverContent>{props.content}</PopoverContent>;

    return (
        <Popover content={popoverContent} trigger="click">
            <QuestionIcon icon={['far', 'question-circle']} />
        </Popover>
    );
}
